/**
 * Come è fatto il listino nuovo rispetto a quello in vigore, in una barra sola: ogni tratto è una parte dei prodotti del
 * fornitore (salgono, scendono, invariati, escono, da verificare), lunga quanto conta. Sotto, la legenda coi numeri.
 */
import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../theme';
import type { Riepilogo } from '../../services/listiniFornitoriService';

const TRATTI = [
  { chiave: 'aumentati', conteggio: 'salgono', colore: tokens.color.warning },
  { chiave: 'scesi', conteggio: 'scendono', colore: tokens.color.success },
  { chiave: 'invariati', conteggio: 'invariati', colore: tokens.color.line },
  { chiave: 'spariti', conteggio: 'escono', colore: tokens.color.ash },
  { chiave: 'da_verificare', conteggio: 'da_verificare', colore: tokens.color.danger },
] as const;

export const BarraDelConfronto: React.FC<{ riepilogo: Riepilogo }> = ({ riepilogo }) => {
  const { t } = useTranslation('listini');
  const tratti = TRATTI.map((x) => ({ ...x, n: riepilogo[x.chiave] ?? 0 })).filter((x) => x.n > 0);
  const totale = tratti.reduce((s, x) => s + x.n, 0);
  if (!totale) return null;
  return (
    <Box>
      <Box role="img" aria-label={tratti.map((x) => t(`conteggi.${x.conteggio}`, { count: x.n })).join(', ')} sx={{ display: 'flex', height: 10, borderRadius: 5, overflow: 'hidden', gap: '2px', bgcolor: tokens.color.lineSoft }}>
        {tratti.map((x) => <Box key={x.chiave} sx={{ flex: x.n, bgcolor: x.colore, minWidth: 4 }} />)}
      </Box>
      <Stack direction="row" flexWrap="wrap" columnGap={2.5} rowGap={0.5} sx={{ mt: 1 }}>
        {tratti.map((x) => (
          <Stack key={x.chiave} direction="row" spacing={0.75} alignItems="center">
            <Box sx={{ width: 10, height: 10, borderRadius: '3px', bgcolor: x.colore, flexShrink: 0 }} />
            <Typography variant="body2" sx={{ fontVariantNumeric: 'tabular-nums' }}>{t(`conteggi.${x.conteggio}`, { count: x.n })}</Typography>
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};
